var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React from 'react';
import { COLOR } from '../../..';
import { TYPOGRAPHY_TYPE, getTypographyStyles } from '../../../theme/typography';
import { defaultRenderOption, getOptionId, } from '../option';
function ListBoxInner(_a, ref) {
    var { options, renderOption: renderOptionParam, selected, focused, selectOption, sx } = _a, rest = __rest(_a, ["options", "renderOption", "selected", "focused", "selectOption", "sx"]);
    const renderOption = renderOptionParam || defaultRenderOption;
    const typography = getTypographyStyles(TYPOGRAPHY_TYPE.PARAGRAPH_MEDIUM);
    return (_jsx("div", Object.assign({ role: "listbox", ref: ref, sx: Object.assign(Object.assign({ border: 'solid 1px', borderRadius: '4px', borderColor: COLOR.LIGHT_GRAY, backgroundColor: COLOR.BACKGROUND, boxShadow: '0px 0px 8px 2px #dddddd' }, typography), sx), onKeyDown: (e) => {
            console.log(e);
        } }, rest, { children: options.map((option) => (_jsx("div", Object.assign({ id: getOptionId(option.value), "aria-selected": selected === option.value, role: "option", onClick: option.onClick, onMouseDown: () => selectOption && selectOption(option), sx: {
                px: 4,
                py: 3,
                backgroundColor: focused === option.value
                    ? COLOR.EXTRA_EXTRA_LIGHT_GRAY
                    : COLOR.BACKGROUND,
                cursor: 'pointer',
                borderBottom: 'solid 1px',
                borderBottomColor: COLOR.LIGHT_GRAY,
                color: COLOR.TEXT,
                ':last-of-type': {
                    borderBottom: 'none',
                    borderBottomRightRadius: '4px',
                    borderBottomLeftRadius: '4px',
                },
                ':first-of-type': {
                    borderTopRightRadius: '4px',
                    borderTopLeftRadius: '4px',
                },
                ':hover': {
                    backgroundColor: COLOR.EXTRA_EXTRA_LIGHT_GRAY,
                },
            } }, { children: renderOption({
                option,
                selected: selected === option.value,
                focused: focused === option.value,
            }) }), option.value))) })));
}
export const ListBox = React.forwardRef(ListBoxInner);
